"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _i18n = require("../../../../Framework/i18n");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _colors = require("@material-ui/core/colors");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ServiceLocator = require("../../../ServiceLocator");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomDialog = _interopRequireDefault(require("../../../../Shared/Components/CustomDialog"));
var _MainButton = _interopRequireDefault(require("../../../../Shared/Components/MainButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var styles = function styles(theme) {
  return {
    dialogTitleRoot: {
      padding: '12px 12px 20px',
      fontSize: '1.5rem',
      fontWeight: 400
    },
    dialogContentRoot: {
      padding: '0 24px 24px 12px'
    },
    pdfDownloadDialog: {
      borderTop: '7px solid ' + theme.palette.primary.main
    },
    activeButton: {
      textTransform: 'none',
      whiteSpace: 'nowrap',
      padding: '4px 15px',
      backgroundColor: _colors.grey[900],
      color: 'white',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: _colors.grey[700]
      }
    },
    activeButtonLabel: {
      color: 'white'
    },
    TypographyCaption: {
      fontSize: 12,
      lineHeight: 1.7
    }
  };
};
var PdfDownload = /*#__PURE__*/function (_React$Component) {
  _inherits(PdfDownload, _React$Component);
  var _super = _createSuper(PdfDownload);
  function PdfDownload() {
    _classCallCheck(this, PdfDownload);
    return _super.apply(this, arguments);
  }
  _createClass(PdfDownload, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        show = _this$props.show,
        onClose = _this$props.onClose;
      return /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
        open: show,
        onClose: onClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        dialogTitle: (0, _i18n.t)('pdfDownloadDialog.title'),
        onCancel: onClose
      }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
        className: classes.dialogContentRoot
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1",
        classes: {
          root: classes.TypographyCaption
        },
        id: "alert-dialog-description"
      }, (0, _i18n.t)('pdfDownloadDialog.content'))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        href: _ServiceLocator.Services.interaction.createPdfUrl('user'),
        target: "_blank",
        variant: "contained",
        classes: {
          root: classes.activeButton,
          label: classes.activeButtonLabel
        }
      }, (0, _i18n.t)('pdfDownloadDialog.actionButton'))));
    }
  }]);
  return PdfDownload;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'PdfDownload'
})(PdfDownload));